export const LOGIN_SUBMIT = 'LOGIN_SUBMIT';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';

export const LOGOUT = 'LOGOUT';

export const REGISTER_SUBMIT = 'REGISTER_SUBMIT';
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';

export const USER_LOCAL_STORAGE_TOKEN_KEY = 'token';
